/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

export function onInitialClientRender() {
  $('.preloader-wrapper').fadeOut()
}
